import { ReactComponent as USA } from "./us.svg";
import { ReactComponent as Austria } from "./at.svg";


type SvgProps = {
    color: Color
}

export const Svgs = {
    EditSvg: (props: SvgProps) => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enableBackground="new 0 0 490.008 490.008"
                version="1.1"
                viewBox="0 0 490.008 490.008"
                xmlSpace="preserve"
            >
                <path fill={props.color} d="M156.7 142.865h88.6c11.5 0 20.8-9.4 20.8-20.9s-9.4-20.9-20.8-20.9h-88.6c-11.5 0-20.8 9.4-20.8 20.9 0 11.5 9.4 20.9 20.8 20.9zM266.1 223.165c0-11.5-9.4-20.9-20.8-20.9h-88.6c-11.5 0-20.8 9.4-20.8 20.9s9.4 20.9 20.8 20.9h88.6c11.5 0 20.8-9.4 20.8-20.9z"></path>
                <ellipse fill={props.color} cx="94.2" cy="122.065" rx="20.5" ry="20.5"></ellipse>
                <ellipse fill={props.color} cx="94.2" cy="223.165" rx="20.5" ry="20.5"></ellipse>
                <path fill={props.color} d="M483.7 258.965l-81.3-81.3c-8.3-8.3-20.8-8.3-29.2 0l-24.3 24.2v-168.5c0-18.4-14.9-33.3-33.3-33.3H33.3c-18.4 0-33.3 15-33.3 33.3v281c0 18.4 14.9 33.3 33.3 33.3h169l-4.1 4c-2.1 3.1-4.2 6.3-5.2 10.4l-20.8 102.2c-3.9 20.1 10.4 28.2 24 25l102.1-20.9c4.2 0 7.3-2.1 10.4-5.2l175-175.1c4.2-4 11.8-15.9 0-29.1zM40 307.765v-267.7h269v201.5l-66.5 66.1H40v.1zm243.7 121.2l-65.6 13.6 13.5-65.7 155.2-155.3 53.1 52.1-156.2 155.3z"></path>
            </svg>
        )
    },
    PlusSvg: (props: SvgProps) => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enableBackground="new 0 0 50 50"
                version="1.1"
                viewBox="0 0 50 50"
                xmlSpace="preserve"
            >
                <circle cx="25" cy="25" r="25" fill={props.color}></circle>
                <path
                    fill="none"
                    stroke="#FFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                    d="M25 13L25 38"
                ></path>
                <path
                    fill="none"
                    stroke="#FFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                    d="M37.5 25L12.5 25"
                ></path>
            </svg>
        )
    },
    MinusSvg: (props: SvgProps) => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enableBackground="new 0 0 50 50"
                version="1.1"
                viewBox="0 0 50 50"
                xmlSpace="preserve"
            >
                <circle cx="25" cy="25" r="25" fill={props.color}></circle>
                <path
                    fill="none"
                    stroke="#FFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                    d="M38 25L12 25"
                ></path>
            </svg>
        )
    },
    ArrowSvg: () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1"
                viewBox="0 0 57.045 56.589"
            >
                <defs>
                    <linearGradient
                        id="linearGradient5602"
                        x1="314.57"
                        x2="332.02"
                        y1="369.98"
                        y2="387.44"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stopColor="#1c97e1"></stop>
                        <stop offset="1" stopColor="#006798"></stop>
                    </linearGradient>
                    <linearGradient
                        id="linearGradient6046"
                        x1="661.46"
                        x2="681"
                        y1="300.41"
                        y2="323.17"
                        gradientTransform="matrix(.80139 0 0 1.2478 -292.85 -373.34)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stopColor="#fff" stopOpacity="0.727"></stop>
                        <stop offset="1" stopColor="#fff"></stop>
                    </linearGradient>
                    <linearGradient
                        id="linearGradient6049"
                        x1="302.74"
                        x2="311.27"
                        y1="377.95"
                        y2="390.78"
                        gradientTransform="matrix(1.9519 0 0 1.8418 -374.85 -700.98)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stopColor="#fff"></stop>
                        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
                    </linearGradient>
                </defs>
                <g color="#000" transform="translate(-213.36 12.443)">
                    <path
                        fill="#166496"
                        d="M339.54 378.06a13.967 13.967 0 11-27.94 0 13.967 13.967 0 1127.94 0z"
                        transform="translate(-374.85 -700.98) scale(1.8961)"
                    ></path>
                    <path
                        fill="url(#linearGradient5602)"
                        stroke="#fff"
                        strokeWidth="0.722"
                        d="M339.54 378.06a13.967 13.967 0 11-27.94 0 13.967 13.967 0 1127.94 0z"
                        transform="translate(-321.18 -638.64) scale(1.7312)"
                    ></path>
                    <path
                        fill="url(#linearGradient6049)"
                        d="M242.43-8.32c-13.34 0-24.17 10.828-24.17 24.175 0 6.412 2.61 12.143 6.69 16.472 2.12-17.501 16.89-31.108 34.96-31.108.49 0 .94.1 1.42.119-4.42-5.75-11.09-9.658-18.9-9.658z"
                    ></path>
                    <path
                        fill="url(#linearGradient6046)"
                        d="M239.2.055l-4.13 4.13 11.7 11.7-11.59 11.589 4.16 4.162 15.72-15.72L239.2.056z"
                    ></path>
                </g>
            </svg>
        );
},
    DownLoadSvg: () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enableBackground="new 0 0 490 490"
                version="1.1"
                viewBox="0 0 490 490"
                xmlSpace="preserve"
            >
                <path d="M245 0c-9.5 0-17.2 7.7-17.2 17.2v331.2L169 289.6c-6.7-6.7-17.6-6.7-24.3 0s-6.7 17.6 0 24.3l88.1 88.1c3.3 3.3 7.7 5 12.1 5 4.4 0 8.8-1.7 12.1-5l88.1-88.1c6.7-6.7 6.7-17.6 0-24.3-6.7-6.7-17.6-6.7-24.3 0L262 348.4V17.1c.1-9.5-7.5-17.1-17-17.1z"></path>
                <path d="M462.1 472.9v-99.7c0-9.5-7.7-17.2-17.2-17.2s-17.2 7.7-17.2 17.2v82.6H62.2v-82.6c0-9.5-7.7-17.2-17.1-17.2s-17.2 7.7-17.2 17.2v99.7c0 9.5 7.7 17.1 17.2 17.1h399.8c9.5 0 17.2-7.6 17.2-17.1z"></path>
            </svg>
        );
    },
    UploadSvg: () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enableBackground="new 0 0 490 490"
                version="1.1"
                viewBox="0 0 490 490"
                xmlSpace="preserve"
            >
                <path d="M262.2 472.9V141.6l58.8 58.8c3.3 3.3 7.7 5 12.1 5 4.4 0 8.8-1.7 12.1-5 6.7-6.7 6.7-17.6 0-24.3L257.1 88c-6.4-6.4-17.8-6.4-24.3 0l-88.1 88.1c-6.7 6.7-6.7 17.6 0 24.3s17.6 6.7 24.3 0l58.8-58.8v331.2c0 9.5 7.7 17.2 17.1 17.2 9.7 0 17.3-7.6 17.3-17.1z"></path>
                <path d="M28 17.1v99.7c0 9.5 7.7 17.2 17.1 17.2 9.5 0 17.2-7.7 17.2-17.2V34.3h365.5v82.6c0 9.5 7.7 17.2 17.1 17.2 9.4 0 17.1-7.7 17.1-17.2V17.1C462 7.6 454.3 0 444.9 0H45.2C35.7 0 28 7.6 28 17.1z"></path>
            </svg>
        )
    },
    ConvertSvg: () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                enableBackground="new 0 0 423.755 423.755"
                version="1.1"
                viewBox="0 0 423.755 423.755"
                xmlSpace="preserve"
            >
                <path d="M43.84 281.457c-18.585-44.869-18.586-94.29 0-139.159 10.649-25.709 26.678-48.152 46.86-66.135l60.86 60.86V15.099H29.635l39.88 39.88c-64.293 58.426-88.5 153.2-53.391 237.959 14.167 34.202 37.07 64.159 66.234 86.634 28.275 21.789 61.873 36.201 97.162 41.677l4.601-29.646c-63.343-9.829-115.784-51.006-140.281-110.146zM407.516 292.938c21.652-52.272 21.652-109.848 0-162.12-14.167-34.202-37.071-64.159-66.234-86.633-28.275-21.79-61.873-36.202-97.162-41.678l-4.601 29.646c63.342 9.829 115.783 51.005 140.28 110.146 18.586 44.869 18.586 94.29 0 139.159-10.649 25.709-26.678 48.152-46.859 66.135l-60.86-60.86v121.924h121.924l-39.801-39.801c22.915-20.757 41.131-46.508 53.313-75.918z"></path>
            </svg>
        );
    },
    FlagSvg: (props: {flag: 'austria' | 'usa'}) => {
        switch (props.flag) {
            case "austria": return <Austria/>
            case "usa": return <USA/>
        }
    }
}
